import {FC, ReactNode} from 'react';
import {FieldError} from 'react-hook-form';
import clsx from 'clsx';
import Icon from 'components/Icon';
import {c} from 'ttag';

export type HelpErrorProps = {
    children?: ReactNode;
    className?: string;
    disabled?: boolean;
    error?: FieldError;
    helpText?: ReactNode;
    label?: ReactNode;
};

const HelpError: FC<HelpErrorProps> = ({
    children,
    className,
    disabled,
    error,
    helpText,
    label,
}) => {
    const errorMessage =
        error?.message ||
        (error && c('component').t`Please complete this required field.`);

    return (
        <div className={clsx('ml-px mt-0.5', className)} role="status">
            <div
                className={clsx(children && 'flex items-start justify-between')}
            >
                {helpText ? (
                    <span
                        className={clsx(
                            'block whitespace-pre-line text-sm',
                            children && 'flex-1 pr-1',
                            disabled
                                ? 'text-light-disabled'
                                : 'text-light-secondary',
                        )}
                        role="note"
                    >
                        {helpText}
                    </span>
                ) : (
                    children && <span className="flex-1 text-sm">&nbsp;</span>
                )}
                {children}
            </div>
            {errorMessage && (
                <div
                    aria-label={typeof label === 'string' ? label : undefined}
                    className="items-center whitespace-pre-wrap text-sm text-coral-700 flex"
                    role="alert"
                >
                    <Icon
                        className="mr-1 text-coral-500"
                        icon="warning_solid"
                        size="base"
                    />
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default HelpError;
